//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function synchronizeProductsService() {
  try {
    const response = await api.post("/produtos/sincronizar-hotmart");
    toast.success(`Sincronização concluída: ${response.data.adicionados} novo(s) produto(s).`);
    return true;
  } catch (error) {
    toast.error("Erro ao sincronizar produtos com Hotmart");
    return false;
  }
}